import decode from 'jwt-decode';

export default class AuthService {

    static setToken(authToken) {
        localStorage.setItem('auth_token', authToken);
    }

    static getToken() {
        return localStorage.getItem('auth_token')
    }

    static setLocalStorageStoreId(storeId) {
        localStorage.setItem('storeId', storeId);
    }

    static getLocalStorageStoreId() {
        return localStorage.getItem('storeId');
    }

    static setLocalStorageRoleId(roleId) {
        localStorage.setItem('roleId', roleId);
    }

    static getLocalStorageRoleId() {
        return localStorage.getItem('roleId');
    }

    static setDoNotRefreshStoreSelection(value) {
        localStorage.setItem('doNotRefreshStoreSelection', value);
    }

    static getDoNotRefreshStoreSelection() {
        return localStorage.getItem('doNotRefreshStoreSelection');
    }

    static getUserId() {
        const authToken = this.getToken();
        try {
            const decoded = decode(authToken);
            return decoded.sub;
        }
        catch (err) {
            return false;
        }
    }

    static isLoggedIn() {
        if (this.getLocalStorageStoreId() !== 'null' && this.getLocalStorageStoreId() !== null) { 
            return true;
        } else {
            const authToken = this.getToken();
            if(authToken && !this.isTokenExpired(authToken)) {
                try {
                    const decoded = decode(authToken);
                    if(decoded.futura_store_id != null) {
                        return true;
                    }
                }
                catch (err) {
                    return false;
                }
            }
        }
    }

    static isAdmin() {
        if (this.getLocalStorageRoleId() == 1) {
            return true;
        } else {
            const authToken = this.getToken();
            try {
                const decoded = decode(authToken);
                return decoded.is_admin;
            }
            catch (err) {
                return false;
            }
        }
        
    }

    // user name
    static getName() {
        const authToken = this.getToken();
        try {
            const decoded = decode(authToken); 
            return decoded.name;
        }
        catch (err) {
            return false;
        }
    }

    // store_location_id
    static getFuturaStoreId() {
        if (this.getLocalStorageStoreId() !== 'null' && this.getLocalStorageStoreId() !== null) { 
            return this.getLocalStorageStoreId();
        } else {
            const authToken = this.getToken();
            try {
                const decoded = decode(authToken);
                return decoded.futura_store_id;
            } catch (err) {
                return false;
            }
        }
    }

    // is_admin value
    static getAdminType() {
        if (this.getLocalStorageStoreId() !== 'null' && this.getLocalStorageStoreId() !== null) { 
            return this.getLocalStorageRoleId();
        } else {
            const authToken = this.getToken();
            try {
                const decoded = decode(authToken);
                return decoded.admin_type;
            } catch (err) {
                return false;
            }
        }
        
    }

    static logout() {
        this.setToken(null);
        sessionStorage.removeItem('store-name');
        sessionStorage.removeItem('store-suburb');
        this.setLocalStorageRoleId(null);
        this.setLocalStorageStoreId(null);
        localStorage.removeItem('permissions');
    }

    static isTokenExpired(authToken) {
        try {
            const decoded = decode(authToken);
            if (decoded.exp < (Date.now() / 1000)) {
                return true;
            }
            
            return false;
            
        }
        catch (err) {
            return true;
        }
    }

    static isDigitalLoyaltyEnabled() {
        return true;
    }


    static setPermissions(permissions) {
        localStorage.setItem('permissions', permissions);
    }

    static getPermissions() {
        return localStorage.getItem('permissions')
    }

    static can(value) {
        const permission = value.toLowerCase();
        const permissionList = this.getPermissions() ? JSON.parse(this.getPermissions()) : [];
        return permissionList.some(item => item.toLowerCase() === permission);
    }
}
